function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { PixiComponent, useApp } from '@inlet/react-pixi';
import * as R from 'unitx/ramda';
import { Viewport } from 'pixi-viewport';
// import Cull from 'pixi-cull'
import React from 'react';
import { wrapComponent, useForwardRef } from 'unitx-ui';
const ReactViewportComp = PixiComponent('Viewport', {
  create: props => {
    const {
      app: {
        renderer,
        ticker
      },
      height,
      width,
      onCreate
    } = props;
    const viewport = new Viewport({
      screenWidth: width,
      screenHeight: height,
      worldWidth: width,
      worldHeight: height,
      ticker,
      interaction: renderer.plugins.interaction,
      passiveWheel: false,
      divWheel: renderer.view
    });
    onCreate === null || onCreate === void 0 ? void 0 : onCreate(viewport);
    viewport.sortableChildren = true;
    viewport.drag().pinch().wheel(); // to avoid dragging when onClick child

    viewport.on('pointerdown', e => {
      if (e.target !== viewport) {
        viewport.plugins.pause('drag');
      } // const { x, y } = viewport.toWorld(e.data.global)


      viewport.isClick = true;
      setTimeout(() => {
        viewport.isClick = false;
      }, 250);
    });
    viewport.on('pointerup', () => {
      viewport.plugins.resume('drag');
    });
    viewport.on('wheel', data => {
      // @ts-ignore
      data.event.preventDefault();
    });
    return viewport;
  },
  applyProps: (mutableViewport, oldProps, newProps) => {
    const {
      transform,
      onPress,
      zoom,
      width,
      height
    } = newProps;
    mutableViewport.resize(width, height);
    mutableViewport.removeListener('click', mutableViewport.clickEvent);

    mutableViewport.clickEvent = e => R.ifElse(R.equals(e.target), () => {
      const {
        x,
        y
      } = mutableViewport.toWorld(e.data.global);
      return R.when(R.isTrue, () => onPress === null || onPress === void 0 ? void 0 : onPress({
        nativeEvent: e,
        position: {
          x,
          y
        }
      }))(mutableViewport.isClick);
    }, R.identity)(e.currentTarget);

    R.unless(R.equals(oldProps.zoom), () => mutableViewport.setZoom(zoom !== null && zoom !== void 0 ? zoom : 1, true))(zoom);
    R.unless(R.equals(oldProps.transform), () => mutableViewport.setTransform(transform === null || transform === void 0 ? void 0 : transform.x, transform === null || transform === void 0 ? void 0 : transform.y, transform === null || transform === void 0 ? void 0 : transform.scaleX, transform === null || transform === void 0 ? void 0 : transform.scaleY, transform === null || transform === void 0 ? void 0 : transform.rotation, transform === null || transform === void 0 ? void 0 : transform.skewX, transform === null || transform === void 0 ? void 0 : transform.skewY, transform === null || transform === void 0 ? void 0 : transform.pivotX, transform === null || transform === void 0 ? void 0 : transform.pivotY))(transform);
    return mutableViewport.on('click', mutableViewport.clickEvent);
  },
  didMount: () => {},
  willUnmount: () => {}
});

function ViewPortElement(props, ref) {
  const {
    children
  } = props,
        rest = _objectWithoutProperties(props, ["children"]);

  const app = useApp();
  const viewportRef = useForwardRef(ref, {}); // Culling
  // const cull = React.useMemo(() => new Cull.Simple(), [])
  // React.useEffect(() => {
  //   cull.addList(viewportRef.current.children)
  //   cull.cull(viewportRef.current.getVisibleBounds())
  //   return () => {
  //     cull.removeList(viewportRef.current.children)
  //   }
  // }, [children])
  // React.useEffect(() => {
  //   /// Culling
  //   PIXI.Ticker.shared.add(() => {
  //     if (viewportRef.current.dirty) {
  //       cull.cull(viewportRef.current.getVisibleBounds())
  //       viewportRef.current.dirty = false
  //     }
  //   })
  // }, [])

  return /*#__PURE__*/React.createElement(ReactViewportComp, _extends({
    ref: viewportRef,
    app: app
  }, rest), children);
}

const PreparedComponent = wrapComponent(ViewPortElement, {
  isForwardRef: true
});
export default PreparedComponent;